import { CCol } from './CCol.js';
import { CContainer } from './CContainer.js';
import { CRow } from './CRow.js';

const CGridPlugin = {
    install: (app) => {
        app.component(CCol.name, CCol);
        app.component(CContainer.name, CContainer);
        app.component(CRow.name, CRow);
    },
};

export { CCol, CContainer, CGridPlugin, CRow };
//# sourceMappingURL=index.js.map
